<template>
  <div class="nx-page meterenergy-statistics-placeholder">
    <el-card shadow="never">
      <div slot="header">
        <span>能源统计分析</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="goRecord">抄表明细</el-button>
      </div>
      <el-alert
        title="占位页：后续在此接入按 billing_month、fee_type、category 的用量趋势、同比环比、部门/区域维度等图表与报表。"
        type="info"
        :closable="false"
        show-icon
      />
      <p class="hint">接口建议预留：POST /api/produce/meter-energy-record/statistics/summary（或独立 statistics 包下 Controller）。</p>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'MeterEnergyStatistics',
  methods: {
    goRecord() {
      this.$router.push('/meterenergy/record/water-sewage')
    }
  }
}
</script>

<style scoped>
.meterenergy-statistics-placeholder {
  padding: 16px;
}
.hint {
  margin-top: 16px;
  color: #64748b;
  font-size: 13px;
}
</style>
